import { Component } from '@angular/core';

@Component({
  selector: 'pla-data-deletion-page',
  templateUrl: './data-deletion-page.component.html',
  styleUrls: ['./data-deletion-page.component.scss']
})
export class DataDeletionPageComponent {}
